import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { catalogService } from '../../shared/services';

export function AssignedTracks() {
  const { data, isLoading } = useQuery({
    queryKey: ['minhas-trilhas'],
    queryFn: catalogService.getMinhasTrilhas,
    retry: 1,
    staleTime: 30000,
  });

  return (
    <section className="mb-8">
      <h2 className="text-xl font-bold text-gray-900 mb-4">Trilhas atribuídas</h2>
      {isLoading ? (
        <div className="card flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
        </div>
      ) : !data || data.length === 0 ? (
        <div className="card text-gray-600">
          Nenhuma trilha foi atribuída a você.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {data.map((trilha) => (
            <Link key={trilha.id} to={`/trilhas/${trilha.slug}`} className="card hover:border-primary-300">
              <div className="flex items-center justify-between gap-3 mb-2">
                <h3 className="font-semibold text-gray-900">{trilha.nome}</h3>
                <span className={`text-xs font-medium px-2 py-1 rounded ${trilha.obrigatoria ? 'bg-amber-100 text-amber-800' : 'bg-gray-100 text-gray-600'}`}>
                  {trilha.obrigatoria ? 'Obrigatória' : 'Eletiva'}
                </span>
              </div>
              <p className="text-sm text-gray-600">{trilha.grupoNome}</p>

              <div className="mt-3">
                <div className="flex items-center justify-between text-xs text-gray-500 mb-1">
                  <span>{trilha.cursosConcluidos} de {trilha.totalCursos} cursos</span>
                  <span>{trilha.percentual}%</span>
                </div>
                <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                  <div className="h-full bg-primary-600" style={{ width: `${trilha.percentual}%` }} />
                </div>
              </div>

              {trilha.prazoEm && (
                <p className={`text-xs mt-2 ${trilha.atrasada ? 'text-red-600 font-medium' : 'text-gray-500'}`}>
                  {trilha.atrasada ? 'Atrasada' : 'Prazo'}: {new Date(trilha.prazoEm).toLocaleDateString('pt-BR')}
                </p>
              )}
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
